<template>
    <div>
        <div v-loading="loadingView"></div>
        <div v-if="!loadingView">
            <router-view :brands="brands" :steps="steps" :structure="structure"></router-view>
        </div>
    </div>
</template>

<script>
import Request from '@/core/QuRequest';

const req = new Request();

export default {
    computed: {
        loadingView () {
            return (this.steps || []).length <= 0 || (this.brands || []).length <= 0 || !this.structure;
        }
    },
    data () {
        return {
            steps: null,
            brands: null,
            // config: null,
            structure: null
        };
    },
    methods: {
        // 获取所有的跟进步骤
        async _getSteps () {
            try {
                const params = {
                    type: '1'
                };
                const res = await req.send(req.Apis.sales.common.config, params);
                if (res.code === 200) {
                    this.steps = [...res.data] || [];
                }
            } catch (err) {
                console.error(`获取进步骤失败：${err.message || '未知错误'}`);
            }
        },

        // 获取品牌
        async _getBrands () {
            try {
                const params = {
                    type: '2'
                };
                const res = await req.send(req.Apis.sales.common.config, params);
                if (res.code === 200) {
                    this.brands = [...res.data] || [];
                }
            } catch (err) {
                console.error(`获取品牌失败：${err.message || '未知错误'}`);
            }
        },

        // 获取组织架构
        async _getStructure () {
            try {
                const res = await req.send(req.Apis.sales.common.structure);
                this.structure = (res.data || {}).id ? [{ ...(res.data || {}) }] : [];
                // this.structure = (res.data || {}).id ? [...res.data.child] : [];
            } catch (err) {
                this.$message.error(`获取组织架构失败：${err.message || '未知错误'}`);
            }
        }
    },
    created () {
        this._getSteps();
        this._getBrands();
        this._getStructure();
    }
};
</script>
